import React from "react";

export function ThreeDMotionIcon({ active }: any) {
  const color = active ? "#ffffff" : "#000000";

  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.55704 2.26575C1.40301 4.09494 0.672836 4.54659 0.755639 4.62187C0.853497 4.71973 8.26059 8.99537 8.44125 9.07064C8.52406 9.10075 16.1419 4.78747 16.3376 4.59176C16.3828 4.55412 8.57675 -0.0226213 8.48642 -3.86485e-05C8.47136 -3.86485e-05 6.70239 1.02371 4.55704 2.26575Z"
        fill={color}
      />
      <path
        d="M0.0254054 5.65311C0.00282283 5.70581 -0.00470471 7.76082 0.00282283 10.2223L0.0254054 14.6937L3.97736 16.9745L7.92932 19.2554L7.9519 14.7313C7.96696 11.1633 7.94437 10.1772 7.87663 10.1094C7.82393 10.0642 6.32595 9.18353 4.54193 8.15978C2.76543 7.13604 1.02657 6.12735 0.680301 5.93163C0.258759 5.6757 0.047988 5.59289 0.0254054 5.65311Z"
        fill={color}
      />
      <path
        d="M13.0331 7.84371L9.09619 10.117V14.6938V19.2705L9.41988 19.0823C9.59301 18.9769 11.3695 17.9457 13.3643 16.8015L16.9926 14.7088L17.0001 10.1321C17.0001 7.61788 16.9926 5.56286 16.985 5.56286C16.97 5.57039 15.1935 6.59414 13.0331 7.84371Z"
        fill={color}
      />
    </svg>
  );
}
